import { IsBoolean, IsEnum, IsNotEmpty, IsOptional, MinLength } from 'class-validator';

import { PublicProfileTypeEnum } from '@onArte/shared/database';
import { ListQuery } from '@onArte/shared/models/common';

export class PublicProfileManagementListQuery extends ListQuery {
  @IsNotEmpty()
  @IsEnum(PublicProfileTypeEnum)
  public type: PublicProfileTypeEnum;

  @IsOptional()
  @MinLength(1)
  public phrase?: string;

  @IsOptional()
  @IsBoolean()
  public activeOnly?: boolean;

  @IsOptional()
  @IsBoolean()
  public verifiedOnly?: boolean;

  @IsOptional()
  @IsBoolean()
  public highlighted?: boolean;

  @IsOptional()
  @IsBoolean()
  public sortByHighlighted?: boolean;

  constructor(
    limit: number | undefined,
    offset: number | undefined,
    type: PublicProfileTypeEnum,
    phrase?: string,
    activeOnly?: boolean,
    verifiedOnly?: boolean,
    highlighted?: boolean,
    sortByHighlighted?: boolean
  ) {
    super(limit, offset);

    this.type = type;
    this.phrase = phrase;
    this.activeOnly = activeOnly;
    this.verifiedOnly = verifiedOnly;
    this.highlighted = highlighted;
    this.sortByHighlighted = sortByHighlighted;
  }
}
